(function () {
  var CONFIG = {
    LINE_CLIENT_ID: '2004461855',
    CALLBACK_URL:   'https://yolo-follow-api.kousuke-kawano.workers.dev/api/line-callback',
    FOLLOW_API_URL: 'https://yolo-follow-api.kousuke-kawano.workers.dev/api/follow',
    LINE_AUTH_BASE: 'https://access.line.me/oauth2/v2.1/authorize',
  };

  var STORAGE_FOLLOWED = 'yolo_followed_directors';
  var STORAGE_LINE_UID = 'yolo_line_user_id';

  function getFollowedList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_FOLLOWED) || '[]'); }
    catch (e) { return []; }
  }

  function isFollowed(handle) {
    return getFollowedList().indexOf(handle) !== -1;
  }

  function saveFollow(handle) {
    var list = getFollowedList();
    if (list.indexOf(handle) === -1) list.push(handle);
    localStorage.setItem(STORAGE_FOLLOWED, JSON.stringify(list));
  }

  function removeFollow(handle) {
    var list = getFollowedList().filter(function (h) { return h !== handle; });
    localStorage.setItem(STORAGE_FOLLOWED, JSON.stringify(list));
  }

  function getLineUserId() {
    return localStorage.getItem(STORAGE_LINE_UID) || null;
  }

  function bumpCount(handle, delta) {
    if (typeof window.__yoloBumpCount === 'function') {
      window.__yoloBumpCount(handle, delta);
    }
  }

  function updateButtonUI(btn) {
    var handle   = btn.dataset.handle;
    var wrap     = btn.closest('.c-director__followWrap');
    var notice   = wrap ? wrap.querySelector('.c-director__followNotice') : null;
    var label    = btn.querySelector('.c-director__followLabel');
    var followed = isFollowed(handle);

    btn.classList.toggle('is-followed', followed);
    btn.setAttribute('aria-pressed', followed ? 'true' : 'false');
    if (label) label.textContent = followed ? 'フォロー中' : 'フォロー';
    // ★修正: フォロー後に表示していた「〜の新着・再販・セール情報をLINEで
    // お知らせします」という案内文を廃止。この文言は幅を制限していなかった
    // ため、一覧ページの行レイアウト(.c-director__rowFollow は flex-shrink:0)
    // でボタンの親要素が文章の長さいっぱいまで広がってしまい、フォロー後に
    // アバターや名前の上にボタンが覆いかぶさるような見た目になっていた。
    // 表示自体が不要とのことなので、常に空にする。
    if (notice) notice.textContent = '';
  }

  function registerFollow(lineUserId, handle, customerId) {
    fetch(CONFIG.FOLLOW_API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lineUserId: lineUserId, director: handle, customerId: customerId })
    }).catch(function(e) { console.error('[YOLO] follow error', e); });

    saveFollow(handle);
    bumpCount(handle, +1);
  }

  function unregisterFollow(lineUserId, handle, customerId) {
    fetch(CONFIG.FOLLOW_API_URL, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lineUserId: lineUserId, director: handle, customerId: customerId })
    }).catch(function(e) { console.error('[YOLO] unfollow error', e); });

    removeFollow(handle);
    bumpCount(handle, -1);
  }

  function redirectToLineLogin(handle, customerId) {
    var state = JSON.stringify({ director: handle, customerId: customerId, redirect: window.location.href });
    var params = new URLSearchParams({
      response_type: 'code',
      client_id:     CONFIG.LINE_CLIENT_ID,
      redirect_uri:  CONFIG.CALLBACK_URL,
      scope:         'profile openid',
      state:         state,
      prompt:        'consent',
      bot_prompt:    'aggressive'
    });
    window.location.href = CONFIG.LINE_AUTH_BASE + '?' + params.toString();
  }

  // ─── v11変更: 会員登録 → ログインページ優先に変更 ───
  // /account/login?return_to=xxx は Shopify が確実に return_to を保持してくれるため、
  // 既存会員のログイン後は元ページに戻る。
  // 新規ユーザーは Shopify のログイン画面から「新規登録」リンクで登録できる。
  function redirectToShopifyAuth(handle) {
    var returnUrl = new URL(window.location.href);
    returnUrl.searchParams.set('pending_follow', handle);
    var returnPath = returnUrl.pathname + returnUrl.search;
    // ログインページに飛ばす(既存会員が多いため)
    window.location.href = '/account/login?return_to=' + encodeURIComponent(returnPath);
  }

  // ─── モーダル共通スタイル ───
  var MODAL_STYLE_INJECTED = false;
  function injectModalStyle() {
    if (MODAL_STYLE_INJECTED) return;
    MODAL_STYLE_INJECTED = true;
    var css = ''
      + '.yolo-follow-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;z-index:9999;padding:20px;opacity:0;transition:opacity .15s ease-out;}'
      + '.yolo-follow-modal-overlay.is-open{opacity:1;}'
      + '.yolo-follow-modal{background:#fff;border-radius:12px;max-width:400px;width:100%;padding:24px 20px;box-shadow:0 20px 40px rgba(0,0,0,0.2);transform:translateY(10px);transition:transform .15s ease-out;}'
      + '.yolo-follow-modal-overlay.is-open .yolo-follow-modal{transform:translateY(0);}'
      + '.yolo-follow-modal__title{font-size:16px;font-weight:bold;line-height:1.5;margin:0 0 12px;color:#111;}'
      + '.yolo-follow-modal__desc{font-size:14px;line-height:1.6;margin:0 0 8px;color:#333;}'
      + '.yolo-follow-modal__note{font-size:12px;line-height:1.6;margin:0 0 20px;color:#999;}'
      + '.yolo-follow-modal__actions{display:flex;gap:10px;flex-direction:column;}'
      + '.yolo-follow-modal__btn{display:block;width:100%;padding:12px 16px;border-radius:8px;font-size:14px;font-weight:bold;text-align:center;cursor:pointer;border:none;line-height:1.2;text-decoration:none;box-sizing:border-box;}'
      + '.yolo-follow-modal__btn--primary{background:#06c755;color:#fff;}'
      + '.yolo-follow-modal__btn--primary:hover{background:#05b64c;}'
      + '.yolo-follow-modal__btn--dark{background:#111;color:#fff;}'
      + '.yolo-follow-modal__btn--dark:hover{background:#333;}'
      + '.yolo-follow-modal__btn--cancel{background:#f5f5f5;color:#333;}'
      + '.yolo-follow-modal__btn--cancel:hover{background:#e8e8e8;}'
      + '@media (min-width:480px){.yolo-follow-modal__actions{flex-direction:row-reverse;}.yolo-follow-modal__btn{flex:1;}}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function closeModal(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 150);
  }

  function showFollowConfirmModal(displayName, onConfirm, onCancel) {
    injectModalStyle();

    var existing = document.querySelector('.yolo-follow-modal-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'yolo-follow-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML =
        '<div class="yolo-follow-modal">'
      +   '<p class="yolo-follow-modal__title">' + escapeHtml(displayName) + ' をフォローしますか？</p>'
      +   '<p class="yolo-follow-modal__desc">新商品・再販情報をLINEでお届けします。</p>'
      +   '<p class="yolo-follow-modal__note">※ LINE公式アカウントとの連携が必要です</p>'
      +   '<div class="yolo-follow-modal__actions">'
      +     '<button type="button" class="yolo-follow-modal__btn yolo-follow-modal__btn--primary js-modal-confirm">フォロー</button>'
      +     '<button type="button" class="yolo-follow-modal__btn yolo-follow-modal__btn--cancel js-modal-cancel">キャンセル</button>'
      +   '</div>'
      + '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });

    overlay.querySelector('.js-modal-confirm').addEventListener('click', function () {
      closeModal(overlay);
      if (typeof onConfirm === 'function') onConfirm();
    });
    overlay.querySelector('.js-modal-cancel').addEventListener('click', function () {
      closeModal(overlay);
      if (typeof onCancel === 'function') onCancel();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal(overlay);
        if (typeof onCancel === 'function') onCancel();
      }
    });
  }

  // 現在ページが該当ディレクターのコレクションページかどうかを判定
  // /collections/{handle} で URL エンコード差異も吸収する
  function isOnCollectionPage(handle) {
    var path = window.location.pathname || '';
    var m = path.match(/^\/collections\/([^\/]+)/);
    if (!m) return false;
    var current = '';
    try { current = decodeURIComponent(m[1]); } catch (e) { current = m[1]; }
    return current === handle;
  }

  function showFollowSuccessModal(displayName, handle) {
    injectModalStyle();

    var existing = document.querySelector('.yolo-follow-modal-overlay');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.className = 'yolo-follow-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    // コレクションページから来たフォローは既にShop内にいるので「閉じる」だけ
    // それ以外は「Shopを見る」CTAを出す
    var onCollectionPage = isOnCollectionPage(handle);

    var actionsHtml;
    if (onCollectionPage) {
      actionsHtml =
          '<div class="yolo-follow-modal__actions">'
        +   '<button type="button" class="yolo-follow-modal__btn yolo-follow-modal__btn--dark js-modal-close">閉じる</button>'
        + '</div>';
    } else {
      var collectionUrl = '/collections/' + encodeURIComponent(handle);
      actionsHtml =
          '<div class="yolo-follow-modal__actions">'
        +   '<a href="' + collectionUrl + '" class="yolo-follow-modal__btn yolo-follow-modal__btn--dark">' + escapeHtml(displayName) + ' のShopを見る</a>'
        +   '<button type="button" class="yolo-follow-modal__btn yolo-follow-modal__btn--cancel js-modal-close">閉じる</button>'
        + '</div>';
    }

    overlay.innerHTML =
        '<div class="yolo-follow-modal">'
      +   '<p class="yolo-follow-modal__title">フォロー完了 🎉</p>'
      +   '<p class="yolo-follow-modal__desc">' + escapeHtml(displayName) + ' をフォローしました。<br>新商品・再販情報をLINEでお届けします。</p>'
      +   '<p class="yolo-follow-modal__note">解除する際は、フォローを外すボタンを再度押してください。</p>'
      +   actionsHtml
      + '</div>';

    document.body.appendChild(overlay);
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });

    overlay.querySelector('.js-modal-close').addEventListener('click', function () {
      closeModal(overlay);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal(overlay);
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function getDisplayName(btn) {
    return btn.dataset.title || btn.dataset.handle || '';
  }

  function findDisplayNameByHandle(handle) {
    var btn = document.querySelector('.js-follow-btn[data-handle="' + handle.replace(/"/g, '\\"') + '"]');
    return btn ? getDisplayName(btn) : handle;
  }

  function handleFollowClick(btn) {
    var handle     = btn.dataset.handle;
    var customerId = btn.dataset.customerId;
    var isLoggedIn = customerId && customerId !== 'false' && customerId !== '';

    if (isFollowed(handle)) {
      unregisterFollow(getLineUserId(), handle, customerId);
      updateButtonUI(btn);
      return;
    }

    var displayName = getDisplayName(btn);
    showFollowConfirmModal(displayName, function onConfirm() {
      if (!isLoggedIn) {
        // ★v11変更: register → login優先(既存会員が return_to を確実に引き継げる)
        redirectToShopifyAuth(handle);
        return;
      }
      var lineUserId = getLineUserId();
      if (lineUserId) {
        registerFollow(lineUserId, handle, customerId);
        updateButtonUI(btn);
        showFollowSuccessModal(displayName, handle);
      } else {
        redirectToLineLogin(handle, customerId);
      }
    });
  }

  function handleLineCallback() {
    var params   = new URLSearchParams(window.location.search);
    var lineUid  = params.get('line_user_id');
    var director = params.get('followed_director');
    if (lineUid) {
      localStorage.setItem(STORAGE_LINE_UID, lineUid);
      if (director) {
        var wasFollowed = isFollowed(director);
        saveFollow(director);
        if (!wasFollowed) bumpCount(director, +1);
      }
      window.history.replaceState({}, '', window.location.pathname);

      if (director) {
        var btn = document.querySelector('.js-follow-btn[data-handle="' + director.replace(/"/g, '\\"') + '"]');
        if (btn) updateButtonUI(btn);

        setTimeout(function () {
          var displayName = findDisplayNameByHandle(director);
          showFollowSuccessModal(displayName, director);
        }, 400);
      }
    }
  }

  function handlePendingFollowResume() {
    var params = new URLSearchParams(window.location.search);
    var pending = params.get('pending_follow');
    if (!pending) return;

    params.delete('pending_follow');
    var newSearch = params.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);

    var btn = document.querySelector('.js-follow-btn[data-handle="' + pending.replace(/"/g, '\\"') + '"]');
    if (!btn) return;
    if (isFollowed(pending)) return;

    setTimeout(function () { handleFollowClick(btn); }, 300);
  }

  function init() {
    handleLineCallback();

    document.querySelectorAll('.js-follow-btn').forEach(function (btn) {
      updateButtonUI(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleFollowClick(btn);
      });
    });

    handlePendingFollowResume();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
